// extracted by mini-css-extract-plugin
export default {"whiteIcon":"ContactSupport_whiteIcon__q5gv6","feedbackLink":"ContactSupport_feedbackLink__iapSi"};